<template>
  <div id="payment_select">
    <dd-header />
    <!-- <div class="title">
      <h1>決済方法選択</h1>
    </div> -->
    <div class="main_content wrapper">
      <dd-menu ref="menuRef"/>
      <div class="payment_select">
        <dd-flow
          :pageKey="pageKey"
          :pageList="orderForm.pageList"
        />
        <div class="wrapper">
          <section class="payment_select" v-if="!isSeikyuPlus">
            <h1>決済方法選択</h1>
            <div>
              <div class="radio">
                <input type="radio" id="const_payment_bank" name="payment_sel" :value="2" v-model.number="paymentType"/>
                <label :for="'const_payment_bank'" class="radio-label bold">銀行振込</label>
              </div>
              <div class="radio">
                <input type="radio" id="const_payment_card" name="payment_sel" :value="1" v-model.number="paymentType"/>
                <label :for="'const_payment_card'" class="radio-label bold">クレジットカード決済</label>
              </div>
            </div>
            <div class="input_error_field">
              <div v-if="errors.paymentType" class="error_text">{{errors.paymentType}}</div>
            </div>
          </section>
          <section class="payment_select" v-else>
            <h1>決済方法選択</h1>
            <div class="selected_payment">
              <div v-if="paymentType===3">掛け払い</div>
              <div v-else-if="paymentType===1">クレジットカード決済</div>
              <div v-else>銀行振込</div>
            </div>
            <div class="other_select link" @click="otherPayment">その他の支払方法を選択する</div>
            <div class="input_error_field">
              <div v-if="errors.paymentType" class="error_text">{{errors.paymentType}}</div>
            </div>
          </section>
          <div class="control_btn_area">
            <div class="detail_btn2" @click="goBack()">もどる</div>
            <div class="detail_btn" @click="complete()">納品先入力</div>
          </div>
        </div>
      </div>
    </div>
    <dd-footer />
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
    <!-- <dd-image-viewer-model /> -->
  </div>
</template>
<script>
// import axios from 'axios'
import * as App from '../../utils/App'
import * as AppEc from '../utils/AppEc'
import {DC_STORAGE_KEY} from '../../constants/App'

import Header from '../components/common/DcHeader'
import Footer from '../components/common/DcFooter'
import DcMenu from '../components/top/DcLeftMenu'
import Flow from '../components/common/Flow'
import LoadingModal from '../../components/common/LoadingModal'

export default {
  name: 'PaymentSelect',
  components: {
    'dd-header': Header,
    'dd-footer': Footer,
    'dd-menu': DcMenu,
    'dd-flow': Flow,
    'dd-loading-modal': LoadingModal
  },
  data () {
    return {
      paymentType: undefined,
      pageKey: 'paymentSelect',
      orderForm: {},
      errors: {},
      userInfo: {}
    }
  },
  computed: {
    isSeikyuPlus: function () {
      if (!this.userInfo) return false
      if (this.userInfo.paymentType === 2) return true
      return false
    }
  },
  methods: {
    goBack: function () {
      this.$router.go(-1)
    },
    complete: function () {
      if (this.paymentType !== 1 && this.paymentType !== 2 && this.paymentType !== 3) {
        this.errors['paymentType'] = 'お支払い方法が選択されていません。'
        this.$forceUpdate()
        return
      }
      console.log('paymentType: ' + this.paymentType)
      App.setLocalStorage(DC_STORAGE_KEY.PAYMENT_TYPE, this.paymentType)
      this.$router.push({
        name: 'OrderInput'
      })
    },
    otherPayment: function () {
      let modalData = {
        onOk: (callback) => {
          this.paymentType = callback.paymentType
        },
        paymentType: this.paymentType
      }
      AppEc.showPaymentSelect(modalData)
    }
  },
  mounted: function () {
    this.userInfo = App.getLocalStorage(DC_STORAGE_KEY.USER_INFO)
    if (this.userInfo.paymentType === 2) {
      this.paymentType = 3
    }
  },
  created () {
    let lorder = App.getLocalStorage(DC_STORAGE_KEY.ORDER_DATA)
    if (Object.keys(lorder).length > 0) {
      this.orderForm = Object.assign({}, lorder)
    }
  }
}
</script>
<style src="../css/dc-order.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/hakotan/pages/DcPaymentSelect.vue